import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49482908"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ram-title"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-icon_signup_nation nation" }, null, -1))
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yonghuming" }, null, -1))
const _hoisted_6 = { class: "requireStart" }
const _hoisted_7 = { class: "el-form-item__is-error ml_20" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_9 = { class: "ml_5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yanzhengmamima" }, null, -1))
const _hoisted_11 = { class: "requireStart" }
const _hoisted_12 = {
  class: "el-form-item__is-error ml_20",
  style: {"position":"relative","top":"15px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_14 = { class: "ml_5 PwdErr" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-querenmima" }, null, -1))
const _hoisted_16 = { class: "requireStart" }
const _hoisted_17 = { class: "el-form-item__is-error ml_20" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_19 = { class: "ml_5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-youjian" }, null, -1))
const _hoisted_21 = { class: "requireStart" }
const _hoisted_22 = { class: "el-form-item__is-error ml_20" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_24 = { class: "ml_5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-youxiangyanzhengma" }, null, -1))
const _hoisted_26 = { class: "requireStart" }
const _hoisted_27 = { class: "el-form-item__is-error ml_20" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_29 = { class: "ml_5" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shoujihao" }, null, -1))
const _hoisted_31 = { class: "pop-select" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "phone-prefix-select" }
const _hoisted_34 = { class: "phone-code" }
const _hoisted_35 = {
  key: 0,
  class: "iconfont icon-shoujihao_shouqi"
}
const _hoisted_36 = {
  key: 1,
  class: "iconfont icon-shoujihao_zhankai"
}
const _hoisted_37 = { class: "phone-prefix-line" }
const _hoisted_38 = { class: "el-form-item__is-error ml_20" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_40 = { class: "ml_5" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-xingming" }, null, -1))
const _hoisted_42 = { class: "el-form-item__is-error ml_20" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_44 = { class: "ml_5" }
const _hoisted_45 = { class: "tooltip_content_prefix" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "requireStart" }
const _hoisted_48 = { class: "center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi tooltip_icon iconfont-tishi" }, null, -1))
const _hoisted_50 = { class: "tooltip_content" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi tooltip_icon" }, null, -1))
const _hoisted_52 = { class: "tooltip_content_text" }
const _hoisted_53 = { class: "el-form-item__is-error ml_20" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_55 = { class: "ml_5" }
const _hoisted_56 = { class: "tooltip_content_prefix" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "flex ter" }
const _hoisted_59 = { class: "el-form-item__is-error ml_20 agreementErr" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi1 err-icon" }, null, -1))
const _hoisted_61 = { class: "ml_5" }
const _hoisted_62 = {
  key: 0,
  class: "regiset-explian"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = {
  key: 0,
  class: "flex ter -end return-tips",
  style: {"justify-content":"flex-end"}
}
const _hoisted_66 = {
  key: 1,
  class: "flex-ter-end fullspread"
}
const _hoisted_67 = {
  key: 1,
  class: "text-ct"
}

import {
  ref,
  reactive,
  onMounted,
  onUnmounted,
  watch
} from 'vue'
import { t, changeLang } from '@/plugins/i18n'
import { signup as createRules } from './rules'
import {
  getSignupCode,
  signup as signApi,
  activateSub,
  checkInvitationCode,
  getEffectTermByType,
  getInvitationInfo
} from '@/apis/login'
import { useGetCode, useLoading } from './utils'
// import {} from "@/components/"
import TermModal from '@/components/termModal/index.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { wait } from '@/plugins/utils'
import { countries, countryOptions } from '../const'
import {
  CountriesEnum,
  Site,
  japanStationCor2Country,
  koreaStationCor2Country,
  ukStationCor2Country,
  Term
} from '@/common/const'

interface Props {
  // string 注册子账号   boolean 弹窗
  isRam?: string | boolean
  // ?
  loginType?: 'home'
}

export default /*#__PURE__*/_defineComponent({
  props: {
    isRam: { type: [String, Boolean], required: false },
    loginType: { type: String, required: false }
  },
  emits: ['success', 'cancel', 'update:panel'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  // string 注册子账号   boolean 弹窗
  isRam?: string | boolean
  // ?
  loginType?: 'home'
}
const aucFunLogo = require('@/assets/image/logos/aucfun-icon.png')
const ivcIco = require('@/assets/image/smc/invitationcode.png')

const store = useStore()



const termModal = ref()
const route = useRoute()
/** 验证推广码是否为推广联盟 */
const isSmcCode = ref(false)
const pwc = ref(true)
const pwcR = ref(true)
const mainAccountCountry = ref(store.getters?.user?.nationCode)
console.log(mainAccountCountry, 'mainAccountCountry')
const toolVisible = ref(false)
const formRef = ref()
const form = reactive({
  countryPlaceCode: CountriesEnum.Japan,
  loginName: '',
  customerName: '',
  password: '',
  repassword: '',
  gender: 3,
  customerEmail: '',
  verificationCode: '',
  // 手机号
  countryCode: '',
  customerMobile: '',
  isagree: false,
  recommendationEmail: '',
  invitationCode: String(route.query.code ?? '')
})
/** 邀请码是否不可编辑 */
const invitationCodeDisable = ref(false)
/** 国家是否不可编辑 */
const countryPlaceCodeDisable = ref(false)

const stationCode = ref<Site>()

const term = ref()
const { count, tip, disabled, getCode } = useGetCode(
  'signupCode',
  getSignupCode
)
/** 通过邀请码获取国家站点信息 */
const countriesInfo = ref({
  country: '',
  stationCode: '',
  langCode: ''
})
const rules = ref(createRules(form, disabled))

const mobileAreaCodeOptions = ref<string[]>([''])
const clientHeight = ref(550)
// 若屏幕占用宽度小于700，则展示h5样式
const showh5Style = ref<boolean>(window.screen?.availWidth < 700)
const find = countries.find((country) => country.key === form.countryPlaceCode)
const [loading, api] = useLoading(() => {
  const { ...data } = form
  // return ;
  return (
    typeof props.isRam === 'string'
      ? activateSub({
        ...form,
        countryPlaceCode: mainAccountCountry.value,
        customerShopId: props.isRam,
        utcTimeZone:
          form.countryPlaceCode === CountriesEnum.other
            ? getTimeZoneByBowser()
            : find?.time as string
      })
      : signApi({
        ...data,
        spm: String(route.query.spm ?? ''),
        channel: String(route.query.channel ?? ''),
        invitationCode: String(form.invitationCode) || String(route.query.code || ''),
        utcTimeZone: form.countryPlaceCode === CountriesEnum.other
          ? getTimeZoneByBowser()
          : find?.time as string,
        termId: term.value.termId,
        buType: 1,
        platformType: 1
      })
  ).then((res) => {
    if (res.success) {
      store.commit('route/SET_LOGIN_NAME', data.loginName)
      emits('success', res.data?.uuid)
      return wait()
    }
  })
})

const texts = [
  '用户名',
  '联系人姓名',
  '密码',
  '再次确认密码',
  '性别',
  '邮箱',
  '验证码',
  '联系电话',
  '已有账号，马上登录',
  '返回首页',
  ''
]
const tips = [
  '请设置用户名',
  '你的名字是？',
  '设置你的登陆密码',
  '请再次输入您的密码',
  '性别',
  '输入邮箱',
  '输入验证码',
  '请输入您的手机号码（选填）',
  '请输入你的Chatwork ID （选填）',
  '请输入你的Skype （选填）',
  '输入Aucfan的注册邮箱',
  '手机号'
]

watch(
  () => form.countryPlaceCode,
  () => {
    rules.value = createRules(form, disabled)
  }
)
/** 走默认配置语言设置 */
const getDefaultOptions = () => {
  // 没有找对应语言的国家，默认日本
  const find = countries.find((item) =>
    item.navigatorLang.includes(store.getters.site || navigator.language)
  ) || {
    key: CountriesEnum.Japan,
    desc: '日本',
    navigatorLang: ['ja'],
    mobileAreaCode: '+81'
  }
  // 缓存国家key JP...  缓存key > 浏览器
  const cacheKey = localStorage.getItem('countryKey') as CountriesEnum
  form.countryPlaceCode = [CountriesEnum.Japan, CountriesEnum.Korea].includes(
    cacheKey
  )
    ? cacheKey
    : find?.key || CountriesEnum.Japan
  localStorage.setItem('countryKey', form.countryPlaceCode)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  mobileAreaCodeOptions.value = [find?.mobileAreaCode]
    .filter((code) => code)
    .concat('')
  // 获取默认站点信息
  if (japanStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.JA
  }
  if (koreaStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.EN
  }
}
/** 通过code获取站点信息 */
const getCountryInvitationInfo = async (code: string) => {
  // 新加接口判断code是正确

  const resInfo = await getInvitationInfo({
    invitationCode: code
  })
  // 说明邀请码不正确
  if (!resInfo.success || !resInfo.data) {
    countriesInfo.value = resInfo.data
    getDefaultOptions()
    return
  }

  countriesInfo.value = resInfo.data

  changeLang(resInfo.data?.langCode as ('ko' | 'ja' | 'en'))
  // stationCode.value = Site.JA
  stationCode.value = resInfo.data?.stationCode as Site

  const find = countries.find((item) =>
    item.navigatorLang.includes(resInfo.data?.langCode || resInfo.data?.stationCode)) ||
  {
    key: CountriesEnum.Japan,
    desc: '日本',
    navigatorLang: ['ja'],
    mobileAreaCode: '+81'
  }

  // 如果国家信息存在则将国家回显
  form.countryPlaceCode = ([CountriesEnum.Japan, CountriesEnum.Korea].includes(
    resInfo.data?.country as CountriesEnum
  )
    ? resInfo.data?.country
    : find?.key || CountriesEnum.Japan) as CountriesEnum
  localStorage.setItem('countryKey', form.countryPlaceCode)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  // console.log('1111111--------', find?.mobileAreaCode)
  // 区号
  mobileAreaCodeOptions.value = [find?.mobileAreaCode]
    .filter((code) => code)
    .concat('')
  // console.log(555555555, resInfo.data?.langCode)
  // 存储
  store.commit('route/site', resInfo.data?.langCode)
}

onMounted(async () => {
  setTimeout(() => {
    // console.log(99999999, route.query.code)
    // 无法获取 route里的值
    form.invitationCode = String(route.query.code ?? '')
    validInvitationCode(form.invitationCode, true)
  }, 100)
  if (document.body.clientHeight >= 700) {
    clientHeight.value = document.body.clientHeight
  }
  showh5Style.value = window.screen?.availWidth < 700

  window.addEventListener('mouseup', mouseupFn, true)

  // 如果路由携带code参数，则是推广者联盟 => 国家固定为日本，且无法选择国家
  if (route.query.code) {
    await getCountryInvitationInfo(route.query.code as string)
    return
  }
  // 默认走缓存语言配置
  getDefaultOptions()
  handleCountryChange(form.countryPlaceCode)
})
onUnmounted(() => {
  window.removeEventListener('mouseup', mouseupFn, true)
})
const mouseupFn = () => {
  toolVisible.value = false
}
const signup = () => {
  const f = formRef.value
  f.validate((valid: boolean) => {
    if (valid) {
      api()
    }
  })
}
const chooseSelect = (str: any) => {
  form.countryCode = str
}

const validInvitationCode = async (val: string, notNeedRequest?: boolean) => {
  // code必须为6位在请求后端接口

  if (!notNeedRequest) {
    await getCountryInvitationInfo(val)
  }

  const res = await checkInvitationCode({
    invitationCode: val
  })
  // console.log(111111, countriesInfo.value)
  if (res?.success) {
    isSmcCode.value = res.data
  }
  // 如果路由上code存在，且为推广码，且该推广码正确
  if (route.query.code && res.data && countriesInfo.value?.country) {
    countryPlaceCodeDisable.value = true
    invitationCodeDisable.value = true
  } else if (res.data && countriesInfo.value?.country) {
    countryPlaceCodeDisable.value = true
    // invitationCodeDisable.value = true
  } else {
    countryPlaceCodeDisable.value = false
    invitationCodeDisable.value = false
  }
  rules.value = createRules(form, disabled)
}
const getSelectedCountryFlagUrl = (key: string) => {
  return countryOptions.find((op) => op.key === key)?.nationalFlagUrl
}

const handleCountryChange = (val: CountriesEnum) => {
  localStorage.setItem('countryKey', val)
  formRef.value.resetFields()
  const find = countries.find((country) => country.key === val)
  let globalLangType: 'en' | 'ja' | 'ko' = 'en'

  form.countryPlaceCode = val
  form.countryCode = find!.mobileAreaCode
  mobileAreaCodeOptions.value = [find!.mobileAreaCode]
    .filter((code) => code)
    .concat('')

  if (japanStationCor2Country.includes(val)) {
    globalLangType = 'ja'
    stationCode.value = Site.JA
  }
  if (koreaStationCor2Country.includes(val)) {
    globalLangType = 'ko'
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(val)) {
    globalLangType = 'en'
    stationCode.value = Site.EN
  }

  store.commit('route/site', globalLangType)
  changeLang(globalLangType!)
}

watch(
  () => stationCode.value,
  (val) => {
    // console.log('-------11111111', val)
    fetchTerm()
  }
)

// 返回浏览器当前的UTC时间偏移量
const getTimeZoneByBowser = () => {
  // 获取本地时间
  const localTime = new Date()

  // 获取UTC时间
  const utcTime = new Date(
    localTime.getTime() + localTime.getTimezoneOffset() * 60000
  )

  // 计算UTC偏移量（以分钟为单位）
  const utcOffset = (localTime.getTimezoneOffset() / 60) * -1

  if (utcOffset >= 0) {
    return `UTC+${utcOffset}`
  } else {
    return `UTC${utcOffset}`
  }
}
const fetchTerm = async () => {
  try {
    const termDataList = await getEffectTermByType({
      stationCode: stationCode.value as Site,
      type: Term.utilize
    })
    term.value = termDataList.data[0]
  } catch { }
}

const open = () => {
  const TermModalInstance = termModal.value
  TermModalInstance.open()
}

const onagree = () => {
  form.isagree = true
}
const ondisAgree = () => {
  form.isagree = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_templete = _resolveComponent("templete")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "panel rel",
    style: _normalizeStyle(clientHeight.value <= 600 ? 'height:580px' : 'height:670px')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["content", { 'pt-55': typeof __props.isRam === 'string' && clientHeight.value > 600 }]),
      style: _normalizeStyle(clientHeight.value <= 600 ? 'transform:scale(0.8)' : 'transform:scale(0.95)'
      )
    }, [
      (typeof __props.isRam === 'string')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)('创建子账号')), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _unref(form),
        rules: rules.value,
        "validate-on-rule-change": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "country",
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"100%"},
                class: _normalizeClass(["conutrySelect", {
              'countrySelector-h5': !!showh5Style.value,
              countrySelector: !showh5Style.value,
              // margin bottom是因为注册页面有个注册提醒，占了30px的宽度
              marginBottom: __props.isRam
            }]),
                modelValue: mainAccountCountry.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mainAccountCountry).value = $event)),
                "popper-class": "h5-drap",
                onChange: handleCountryChange,
                disabled: countryPlaceCodeDisable.value || !!__props.isRam
              }, {
                prefix: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("span", {
                    class: _normalizeClass(showh5Style.value ? 'required-h5' : 'required')
                  }, null, 2),
                  _createElementVNode("img", {
                    src: getSelectedCountryFlagUrl(mainAccountCountry.value),
                    alt: mainAccountCountry.value,
                    class: "selected-countryFlag"
                  }, null, 8, _hoisted_4)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryOptions), (op) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: op.key,
                      value: op.key,
                      label: op.desc,
                      class: _normalizeClass(showh5Style.value ? 'op-h5' : 'op')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: op.nationalFlagUrl,
                          alt: op.desc,
                          class: "op-img"
                        }, null, 8, _hoisted_2),
                        _createElementVNode("span", null, _toDisplayString(op.desc), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label", "class"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "class"])
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("p", { class: "selectTip" }, _toDisplayString(_unref(t)('注册成功后国家/地区无法更改，请谨慎选择')), 513), [
            [_vShow, !__props.isRam]
          ]),
          _createVNode(_component_el_form_item, {
            prop: "loginName",
            ref: (_value, _refs) => {
              _refs['nameRef'] = _value
            }
          }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).loginName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).loginName) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[0]),
                maxlength: 18,
                autocomplete: "off"
              }, {
                prefix: _withCtx(() => [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("span", _hoisted_6, "*", 512), [
                    [_vShow, !_unref(form).loginName]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_el_form_item, {
            prop: "password",
            id: "password"
          }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: pwc.value ? 'password' : 'text',
                modelValue: _unref(form).password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).password) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[2]),
                maxlength: 32,
                autocomplete: "new-password",
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (formRef.value.validateField(['password', 'repassword'])))
              }, {
                prefix: _withCtx(() => [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("span", _hoisted_11, "*", 512), [
                    [_vShow, !_unref(form).password]
                  ])
                ]),
                suffix: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["btn eye primary fa iconfont", pwc.value ? 'icon-biyan' : 'icon-zhengyan']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (pwc.value = !pwc.value))
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["type", "modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "repassword" }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: pwcR.value ? 'password' : 'text',
                modelValue: _unref(form).repassword,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).repassword) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[3]),
                maxlength: 32,
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (formRef.value.validateField(['password', 'repassword'])))
              }, {
                prefix: _withCtx(() => [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("span", _hoisted_16, "*", 512), [
                    [_vShow, !_unref(form).repassword]
                  ])
                ]),
                suffix: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["btn eye primary fa iconfont", pwcR.value ? 'icon-biyan' : 'icon-zhengyan']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (pwcR.value = !pwcR.value))
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["type", "modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "customerEmail" }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "email",
                modelValue: _unref(form).customerEmail,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[5]),
                maxlength: 50
              }, {
                prefix: _withCtx(() => [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("span", _hoisted_21, "*", 512), [
                    [_vShow, !_unref(form).customerEmail]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", _hoisted_29, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(form).verificationCode,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[6]),
                maxlength: 106
              }, {
                prefix: _withCtx(() => [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("span", _hoisted_26, "*", 512), [
                    [_vShow, !_unref(form).verificationCode]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_el_button, {
                class: "codebtn",
                style: {"width":"160px","margin":"-2px -5px 0 0"},
                type: "primary",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (
            _unref(getCode)(_unref(form).customerEmail, _unref(getSignupCode), _unref(form).countryPlaceCode)
            )),
                disabled: _unref(count) > 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(count) > 0 ? _unref(tip) : _unref(t)('获取验证码')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          ((typeof __props.isRam !== 'string'))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "customerMobile"
              }, {
                error: _withCtx((valid) => [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("span", _hoisted_40, _toDisplayString(valid.error), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "email",
                    modelValue: _unref(form).customerMobile,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)(tips[11]),
                    maxlength: 50,
                    class: _normalizeClass(showh5Style.value ? 'phone-input-h5' : 'phone-input')
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_30,
                      _createVNode(_component_el_tooltip, {
                        placement: "bottom",
                        trigger: "click",
                        visible: toolVisible.value,
                        effect: "light",
                        "popper-class": "signup-phone-tool",
                        offset: 0
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (code) => {
                              return (_openBlock(), _createElementBlock("div", { key: code }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (chooseSelect(code)),
                                  class: _normalizeClass([
                        {
                          active: _unref(form).countryCode === code,
                        },
                        'pop-select-item',
                      ])
                                }, _toDisplayString(code || _unref(t)('不写区号')), 11, _hoisted_32)
                              ]))
                            }), 128))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (toolVisible.value = true)),
                            class: "phone-prefix"
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(form).countryCode || '-'), 1),
                              (toolVisible.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                                : _createCommentVNode("", true),
                              (!toolVisible.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_37, null, 512), [
                              [_vShow, !_unref(form).customerMobile]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { prop: "customerName" }, {
            error: _withCtx((valid) => [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", _hoisted_44, _toDisplayString(valid.error), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(form).customerName,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).customerName) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[1]),
                maxlength: 18
              }, {
                prefix: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          (Number(_unref(route).query?.channel) === 1)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                prop: "recommendationEmail"
              }, {
                error: _withCtx((valid) => [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("span", _hoisted_55, _toDisplayString(valid.error), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).recommendationEmail,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).recommendationEmail) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)(tips[10]),
                    maxlength: 50
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("img", {
                          src: _unref(aucFunLogo),
                          class: "tooltip_content_logo"
                        }, null, 8, _hoisted_46),
                        _withDirectives(_createElementVNode("span", _hoisted_47, "*", 512), [
                          [_vShow, !_unref(form).verificationCode]
                        ])
                      ])
                    ]),
                    suffix: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_el_popover, {
                          ref: (_value, _refs) => {
                            _refs['popover'] = _value
                          },
                          placement: "top",
                          width: 300,
                          trigger: "hover"
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_49
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(t)('输入Aucfan的注册邮箱提示')), 1)
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }))
            : _withDirectives((_openBlock(), _createBlock(_component_templete, { key: 2 }, {
                default: _withCtx(() => [
                  ((typeof __props.isRam !== 'string'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "invitationCode"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _unref(form).invitationCode,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).invitationCode) = $event)),
                            readonly: invitationCodeDisable.value,
                            placeholder: _unref(t)('邀请码(选填)'),
                            maxlength: "6",
                            onChange: validInvitationCode
                          }, {
                            prefix: _withCtx(() => [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("img", {
                                  src: _unref(ivcIco),
                                  class: "tooltip_content_logo"
                                }, null, 8, _hoisted_57)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "readonly", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512)), [
                [_vShow, _unref(form).countryPlaceCode === _unref(CountriesEnum).Japan || _unref(form).countryPlaceCode === _unref(CountriesEnum).Korea]
              ]),
          ((typeof __props.isRam !== 'string'))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                prop: "isagree",
                label: "",
                class: "ml_15 argeement",
                style: {"margin-top":"-10px"}
              }, {
                error: _withCtx((valid) => [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("span", _hoisted_61, _toDisplayString(valid.error), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(form).isagree,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).isagree) = $event)),
                      size: "large"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("a", {
                      onClick: open,
                      class: "btn ft-w-6 mean"
                    }, _toDisplayString(_unref(t)('同意以下条款')), 1)
                  ]),
                  (isSmcCode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          effect: "dark"
                        }, {
                          content: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('为了告知介绍大使会员的用户名')), 1),
                            _hoisted_63,
                            _createTextVNode(" " + _toDisplayString(_unref(t)('请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。')), 1),
                            _hoisted_64,
                            _createTextVNode(" " + _toDisplayString(_unref(t)('如果用户名中包含您的个人信息，请事先同意提供给推广者会员。')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('注册信息隐私说明')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ((typeof __props.isRam !== 'string'))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                style: {"margin-top":"40px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "signup",
                    loading: _unref(loading),
                    onClick: signup
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('注册并登录')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  (props.loginType !== 'home')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)(texts[8])), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider, {
                          direction: "vertical",
                          style: {"border-color":"#565656"}
                        }),
                        _createVNode(_component_router_link, { to: "/" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)(texts[9])), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", {
                          class: "cursor-pt varcolor",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(store).commit('status/loginPanel', 'login')))
                        }, _toDisplayString(_unref(t)(texts[8])), 1)
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      ((typeof __props.isRam === 'string'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _createVNode(_component_el_button, {
              type: "default",
              class: "cancel-btn",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (emits('cancel')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "ram-btn create-btn",
              loading: _unref(loading),
              onClick: signup
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('创建')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ], 6),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModal'] = _value
        termModal.value = _value
      },
      title: _unref(t)('利用规约'),
      onagree: onagree,
      "ondis-agree": ondisAgree,
      "file-url": term.value?.fileUrl,
      timer: false
    }, null, 8, ["title", "file-url"])
  ], 4))
}
}

})